import React from 'react';
import packageInfo from '../../../package.json'
    
var version = packageInfo.version

const Footer = () => {
  return (
    <footer className="mt-5 p-4 text-center">
      <span className="colorNavy">
      Forest Hills Cemetery | 423.821.4161 | Fax 423.821.8740 | <a href="mailto:foresthillscemetery@gmail.com?subject=Forest Hills Cemetery Website Inquiry">foresthillscemetery@gmail.com</a><br />
      Web site and hosting by <a href="http://www.totalwebsystems.com">Total Web Systems</a> | v{ version }
      </span>      
    </footer>
  )
}

export default Footer
